// extracted by mini-css-extract-plugin
module.exports = {"title":"ProcessingDirectionTitle_title__13xnl"};